import AddLiveQuiz from "@/modules/omnilearning/components/AddLiveQuiz";
import AddLiveQuizForm from "@/modules/omnilearning/components/AddLiveQuizForm";

import StudentQuizReport from "@/modules/omnilearning/components/StudentQuizReport";

import LiveQuiz from "@/modules/omnilearning/components/LiveQuiz";

export default [
    {
        path: "/addlivequiz",
        name: "AddLiveQuiz",
        component: AddLiveQuiz,
    },
    {
        path: "/addlivequiz/form",
        name: "AddLiveQuizForm",
        component: AddLiveQuizForm,
    },
    {
        path: "/student-report",
        name: "StudentQuizReport",
        component: StudentQuizReport,
    },
    {
        path: "/live-quiz",
        name: "LiveQuiz",
        component: LiveQuiz,
    },
];



// WEBPACK FOOTER //
// ./src/modules/omnilearning/router/omnilearning.js